const COUPON_STATUSES = {
  initial: { name: "initial", id: 9 },
  active: { name: "active", id: 13 },
  shared: { name: "shared", id: 13 },
  expired: { name: "expired", id: 18 },
  used: { name: "used", id: 14 },
  locked: { name: "locked", id: 19 },
  reserved: { name: "reserved", id: 9 },
};

export default COUPON_STATUSES;
